import { render, staticRenderFns } from "./ImportTest.vue?vue&type=template&id=5f6d34a6&scoped=true&"
import script from "./ImportTest.vue?vue&type=script&lang=js&"
export * from "./ImportTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d34a6",
  null
  
)

export default component.exports